"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PiggyBankIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PiggyBankIcon, _PureComponent);

  function PiggyBankIcon() {
    _classCallCheck(this, PiggyBankIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(PiggyBankIcon).apply(this, arguments));
  }

  _createClass(PiggyBankIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 42.436 37.722",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("path", {
        className: "a",
        d: "M41.279,16.5H39.106a11.824,11.824,0,0,0-2.755-3.868l1.392-5.562H35.385A7.028,7.028,0,0,0,30.007,9.6a11.685,11.685,0,0,0-1.695-.169h-9.43a11.8,11.8,0,0,0-11.552,9.43H4.147a1.77,1.77,0,0,1-1.731-2.122A1.815,1.815,0,0,1,4.22,15.324h.074a.443.443,0,0,0,.442-.442V13.409a.443.443,0,0,0-.442-.442A4.22,4.22,0,0,0,.058,16.547a4.129,4.129,0,0,0,4.089,4.671H7.094A11.741,11.741,0,0,0,11.809,30.6v5.946a1.182,1.182,0,0,0,1.179,1.179H17.7a1.182,1.182,0,0,0,1.179-1.179V33.006h9.43v3.536a1.182,1.182,0,0,0,1.179,1.179h4.715a1.182,1.182,0,0,0,1.179-1.179V30.6a11.79,11.79,0,0,0,2.306-2.306h3.588a1.182,1.182,0,0,0,1.179-1.179v-9.43A1.182,1.182,0,0,0,41.279,16.5Zm-9.43,4.715a1.179,1.179,0,1,1,1.179-1.179A1.182,1.182,0,0,1,31.849,21.218ZM18.882,7.073h9.43c.4,0,.788.029,1.171.059,0-.022.007-.037.007-.059a7.073,7.073,0,0,0-14.146,0c0,.155.037.3.044.457A14.005,14.005,0,0,1,18.882,7.073Z",
        transform: "translate(-0.022)"
      }));
    }
  }]);

  return PiggyBankIcon;
}(_react.PureComponent);

exports.default = PiggyBankIcon;